export const ActionTypes = {
    GET_CHART_OF_ACCOUNTS : "GET_CHART_OF_ACCOUNTS",
    GET_FUNDS:"GET_FUNDS",
    GET_TXN_TYPE_CATEGORY: "GET_TXN_TYPE_CATEGORY",
    GET_TXN_TYPES: "GET_TXN_TYPES",
    SET_STRING_VALUE: "SET_STRING_VALUE",
    SET_THEME_MODE: "SET_THEME_MODE"
}